import {inlineError, tracer} from '@s-ui/decorators'
import {UseCase} from '@s-ui/domain'

import {FeatureNotEnabledError} from '../../shared/Errors/FeatureNotEnabledError.js'
import {SeoRepositoriesFactory} from '../Repositories/factory.js'
import {GetVehicleConfiguratorSeoDataRequest} from '../Requests/GetVehicleConfiguratorSeoDataRequest.js'
import {VehicleConfiguratorSeoDataValueObject} from '../ValueObjects/VehicleConfiguratorSeoDataValueObject.js'

class GetVehicleConfiguratorSeoDataSeoUseCase extends UseCase {
  #repository
  #config
  #isFeatureEnabled

  constructor({config, repository}) {
    super()
    this.#repository = repository
    this.#config = config
    this.#isFeatureEnabled = config.get('APP_NAME') !== config.get('APP_NAME_MOTOS')
  }

  static create({config}) {
    return new GetVehicleConfiguratorSeoDataSeoUseCase({
      config,
      repository: SeoRepositoriesFactory.hTTPSeoRepository({config})
    })
  }

  @tracer({metric: 'GetVehicleConfiguratorSeoDataSeoUseCase#execute'})
  @inlineError
  async execute({makeName, makeSlug, modelName, modelSlug} = {}) {
    if (!this.#isFeatureEnabled) {
      return Promise.reject(FeatureNotEnabledError.create('Feature not enabled'))
    }
    const getVehicleConfiguratorSeoDataRequest = GetVehicleConfiguratorSeoDataRequest.create({
      makeName,
      makeSlug,
      modelName,
      modelSlug
    })

    return VehicleConfiguratorSeoDataValueObject.create({
      makeName: getVehicleConfiguratorSeoDataRequest.makeName,
      makeSlug: getVehicleConfiguratorSeoDataRequest.makeSlug,
      modelName: getVehicleConfiguratorSeoDataRequest.modelName,
      modelSlug: getVehicleConfiguratorSeoDataRequest.modelSlug
    })
  }
}

export const factory = GetVehicleConfiguratorSeoDataSeoUseCase.create
